import { Switch } from "@/components/ui/switch";
import { toast } from "components/ui/use-toast";
import { useToggleNcmMutation } from "@/services/ncm";

interface ToggleStatusSwitchProps {
  id: number;
  isActive: boolean;
}

export const ToggleStatusSwitch: React.FC<ToggleStatusSwitchProps> = ({
  id,
  isActive,
}) => {
  const [toggleNcm, { isLoading }] = useToggleNcmMutation();

  const handleToggleStatus = async () => {
    try {
      await toggleNcm(id).unwrap();
      toast({
        title: "Sucesso",
        description: `Item ${isActive ? "inativado" : "ativado"} com sucesso!`,
        variant: "success",
      });
    } catch (error) {
      console.error("Erro ao alterar status do item", error);
      toast({
        title: "Erro ao alterar status do item.",
        variant: "destructive",
      });
    }
  };

  return (
    <Switch
      checked={isActive}
      onCheckedChange={handleToggleStatus}
      disabled={isLoading}
    />
  );
};
